export enum ERROR_MESSAGE {
  require = "비어 있는 정보를 입력해 주세요",
  email = "이메일 형식이 올바르지 않습니다",
  passwordConfirm = "비밀번호와 비밀번호 확인은 같아야 합니다",
  phone = "연락처는 핸드폰 번호를 입력해 주세요",
}
